import { PLEASE_SELECT_QHP_OBJECT, UNASSIGNED_QHP_OBJECT } from '../../../constants/visit';

export interface QhpGroup {
    name: string;
    order: number;
}

export interface QhpEligibilityFlags {
    isCareTeam: boolean;
    isEligible: boolean;
    isAvailable: boolean;
    // When availability is unknown (e.g. a past visit) we group on eligibility only.
    availabilityKnown: boolean;
}

const SENTINEL_QHP_IDS = new Set([UNASSIGNED_QHP_OBJECT.uuid, PLEASE_SELECT_QHP_OBJECT.uuid]);

// The "Unassigned" / "Please select" options are not real QHPs and carry no group.
export const isSentinelQhpId = (uuid: string): boolean => SENTINEL_QHP_IDS.has(uuid);

// Maps a QHP's eligibility flags to its display group name and sort order. Care-team QHPs sort
// above non-care-team; within each, more eligible/available sorts first.
export const groupForQhp = ({
    isCareTeam,
    isEligible,
    isAvailable,
    availabilityKnown,
}: QhpEligibilityFlags): QhpGroup => {
    const name = [
        isCareTeam ? 'Care Team' : null,
        isEligible ? 'Eligible' : 'Ineligible',
        availabilityKnown ? (isAvailable ? 'Available' : 'Unavailable') : null,
    ]
        .filter(Boolean)
        .join(' and ');
    const order =
        (isCareTeam ? 0 : 4) +
        (availabilityKnown ? (isEligible ? 0 : 2) + (isAvailable ? 0 : 1) : isEligible ? 0 : 1);
    return { name, order };
};
